import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import StockDetail from './pages/StockDetail';
import Stocks from './pages/Stocks';
import WhyIsItMoving from './pages/WhyIsItMoving';
import Configuration from './pages/Configuration';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import CheckEmail from './pages/CheckEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Billing from './pages/Billing';
import BillingSuccess from './pages/BillingSuccess';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Blog from './pages/Blog';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Success from './pages/Success';
import AdminPage from './pages/AdminPage';
import WatchlistPage from './pages/Watchlist';
import AlertsPage from './pages/Alerts';
import TicketsPage from './pages/Tickets';
import SimsPage from './pages/admin/Sims';
import ReturnTrackingAdmin from './pages/admin/ReturnTracking';
import AdminUsers from './pages/admin/Users';
import Navigation from './components/Navigation';
import AppTour from './components/AppTour';
import { AuthProvider } from './contexts/AuthContext';
import { TourProvider } from './contexts/TourContext';
import { WatchlistProvider } from './hooks/useWatchlist';
import { QuoteProvider } from './context/QuoteContext';
import { Toaster } from 'sonner';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <TourProvider>
        <WatchlistProvider>
          <QuoteProvider>
            <div className="App min-h-screen" style={{ backgroundColor: '#0B0F1A' }}>
              <BrowserRouter>
                <AppTour />
                <Routes>
                  {/* Public marketing pages - no navigation */}
                  <Route path="/" element={<Home />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/success" element={<Success />} />
                  <Route path="/billing/success" element={<BillingSuccess />} />
                  
                  {/* Public SEO stock pages - crawlable by Google */}
                  <Route path="/stocks" element={<Stocks />} />
                  <Route path="/stocks/:symbol/why-is-it-moving" element={<WhyIsItMoving />} />
                  
                  {/* Hidden Admin pages - no navigation, no links */}
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/admin/sims" element={<SimsPage />} />
                  <Route path="/admin/returns" element={<ReturnTrackingAdmin />} />
                  <Route path="/admin/users" element={<AdminUsers />} />
                
                {/* Auth pages - no navigation */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/check-email" element={<CheckEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                
                {/* App pages - with navigation (protected area) */}
                <Route path="/app/*" element={
                  <>
                    <Navigation />
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/stock/:symbol" element={<StockDetail />} />
                      <Route path="/config" element={<Configuration />} />
                      <Route path="/billing" element={<Billing />} />
                      <Route path="/watchlist" element={<WatchlistPage />} />
                      <Route path="/alerts" element={<AlertsPage />} />
                      <Route path="/tickets" element={<TicketsPage />} />
                    </Routes>
                  </>
                } />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
          </div>
          </QuoteProvider>
        </WatchlistProvider>
      </TourProvider>
    </AuthProvider>
  );
}

export default App;
